<footer class="footer-login">
	<div class="hidden-md hidden-lg">
		<center>
			<a href="#" id="js-imprint">{{TR "Impressum"}}</a> |
			<a href="#" id="js-terms">{{TR "Nutzungsbedingungen"}}</a> |
			<a href="#" id="js-gdpr">{{TR "Datenschutzhinweis"}}</a>
			<br />
			{{{COPYRIGHT}}}
		</center>
	</div>
	<div class="visible-md visible-lg">
		<div class="pull-right">{{{COPYRIGHT}}}</div>
		<div class="pull-left">
			<a href="#" id="js-imprint">{{TR "Impressum"}}</a> |
			<a href="#" id="js-terms">{{TR "Nutzungsbedingungen"}}</a> |
			<a href="#" id="js-gdpr">{{TR "Datenschutzhinweis"}}</a>
		</div>
	</div>
</footer>
